import { render, staticRenderFns } from "./ServiceTitle.vue?vue&type=template&id=deaa5fb4&scoped=true&"
import script from "./ServiceTitle.vue?vue&type=script&lang=js&"
export * from "./ServiceTitle.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTitle.vue?vue&type=style&index=0&id=deaa5fb4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deaa5fb4",
  null
  
)

export default component.exports